// import './App.css';
// import React from "react";
// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import LandingPage from "./Components/Konn3ct LP";
// import FeaturesPage from "./Components/Konn3ct FP";
// import CustomerPage from "./Components/Konn3ctCustomer";
// import PricingPage from "./Components/Kpricing";
// // import Kpricing from "./Components/PriceP1";

// import AboutUs from "./Components/Konn3ctAbout";
// import Changelog from './Components/Konn3ctChangeL';
// import Konn3ctTC from "./Components/Konn3ctTerms";
// import Konn3ctPP from "./Components/KonnectPolicy";
// import Konn3ctDevs from "./Components/Konn3ctDevs";
// import EventsPage from "./Components/Konn3ctEvents"
// import EventDetails from "./Components/KonnectEventId";

// // import Konn3ctFooter from "./Components/Konn3ct 4";

// // import combineApp from "./Components/combine";

// // import Landing from './Components/holdest';

// const App = () => {
//   return (
//     <div>
//        <Router>
//         <Routes>
//       <Route path='/' element={<LandingPage />} />
//       <Route path='/Meet' element={<LandingPage />} />
//       <Route path='/Features' element={<FeaturesPage />} />
//       <Route path='/Customers' element={<CustomerPage />} />
//       <Route path='/Pricing' element={<PricingPage />} />
//       <Route path='/AboutUs' element={<AboutUs />} />
//       <Route path='/ChangeLog' element={<Changelog />} />
//       <Route path='/Konn3ctTC' element={<Konn3ctTC />} />
//       <Route path='/Konn3ctPP' element={<Konn3ctPP />} />
//       <Route path='/Konn3ctDevs' element={<Konn3ctDevs />} />
//       <Route path='/EventsPage' element={<EventsPage />} />
//       <Route path="/event/:ref" element={<EventDetails />} />
//          </Routes>
//       {/* <Route path='/Konn3ctDevs' element={<Konn3ctDevs />} /> */}

//        </Router> 

    
//       {/* <Landing/> */}

//       {/* <LandingPage/> */}
//       {/* <FeaturesPage/> */}
//       {/* <CustomerPage/> */}
          // <PricingPage/> */}
//           {/* <AboutUs/> */}
        

          

//       {/* <Konn3ctFooter /> */}    
//       {/* <BoxGrid/> */}
    

//       {/* <combineApp/> */}
      
//  {/* <Konn3ctFooter /> */}
//       {/* <Kpricing/> */}
//     </div>
//   );
// };

// export default App;



import './App.css';
import React from "react";
// import Konn3ctHeader from "./Components/Header & Footer/Konn3ctHeader";

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ScrollToTop from "./Components/scrollTop";  
import LandingPage from './Components/Landing Page/Konn3ct LP';
import FeaturesPage from './Components/Features Page/Konn3ct FP';
import CustomerPage from "./Components/Customers Page/Konn3ctCustomer";
import PricingPage from './Components/Pricing Page/Kpricing';
import AboutUs from "./Components/About Page/Konn3ctAbout";
import Changelog from './Components/Changelog/Konn3ctChangeL';
import Konn3ctTC from "./Components/Terms & Conditions/Konn3ctTerms";
import Konn3ctPP from "./Components/Privacy Policy/KonnectPolicy";
import Konn3ctDevs from "./Components/Developers/Konn3ctDevs";
import EventsPage from './Components/Events/Konn3ctEvents';
import EventDetails from './Components/Events/KonnectEventId';
import BlogPage from './Components/Blogs/Konn3ctBlog';
import BlogDetails from './Components/Blogs/Konn3ctBlogId';
import MediaPage from "./Components/Gallery/Media";
// import LiveChat from "./Components/LiveChat/LiveChat";
// import BookingPage from "./Components/Schedule/BookingPage";
// import LeftPanel from "./Components/Schedule/LeftPanel";
// import TimeSlots from "./Components/Schedule/TimeSlots";
// import CalendarGrid from "./Components/Schedule/CalendarGrid";
// import BookingForm from "./Components/Schedule/BookingForm"

const App = () => {
  return (
    <div>
      <Router>

        <ScrollToTop /> 
      {/* <Konn3ctHeader /> */}

        <Routes>
          <Route path='/' element={<LandingPage />} />
          <Route path='/Meet' element={<LandingPage />} />
          <Route path='/Features' element={<FeaturesPage />} />
          <Route path='/Customers' element={<CustomerPage />} />
          <Route path='/Pricing' element={<PricingPage />} />
          <Route path='/AboutUs' element={<AboutUs />} />
          <Route path='/ChangeLog' element={<Changelog />} />
          <Route path='/Konn3ctTC' element={<Konn3ctTC />} />
          <Route path='/Konn3ctPP' element={<Konn3ctPP />} />
          <Route path='/Konn3ctDevs' element={<Konn3ctDevs />} />
          <Route path='/EventsPage' element={<EventsPage />} />
          <Route path="/event/:ref" element={<EventDetails />} />
          <Route path='/BlogPage' element={<BlogPage />} />
                    <Route path="/blog/:id" element={<BlogDetails />} />
                              <Route path='/Gallery' element={<MediaPage />} />
{/* <Route path="/book" element={<BookingPage />} /> */}

          {/* <Route path='/Post' element={<Post />} />
          <Route path='/Vlog' element={<Vlog />} /> */}

        </Routes>
{/* <LiveChat /> */}
      </Router>   
   
          {/* <LeftPanel/>
          <TimeSlots/>
          <CalendarGrid/>
          <BookingForm/> */}

    </div>
  );
};

export default App;
